module.exports = __webpack_public_path__ + "img/adulto15.c0c82b35.jpg";